import Colors from './Colors';
import { Platform } from 'react-native';

// default styling for all stack navigation headers headers
const all = {
  headerShown: false,
  gestureEnabled: true,
  // we set the following for screens that overwrite headerSHown and show their header
  headerTitleStyle: {
    fontSize: 26, //28
    fontWeight: 'bold',
    color: Colors.lightText,
  },
  headerStyle: {
    backgroundColor: Colors.blue,
    shadowColor: 'transparent',
    borderBottomWidth: 0,
  },
  headerBackTitleStyle: {
    color: Colors.lightText
  },
  headerTintColor: Colors.lightText,
  headerBackTitleVisible: false,
}
// styling for inner stacks (contractor, search, edit, gallery etc)
const innerStacks = {
  headerShown: false,
  gestureEnabled: true,
}
// styling for sign up stack
const signUp = {
  headerShown: false,
  headerTitleStyle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: Colors.lightText,
  },
  headerStyle: {
    backgroundColor: Colors.blue,
    // backgroundColor: 'red',
    shadowColor: 'transparent',
    borderBottomWidth: 0,
  },
  headerBackTitleStyle: {
    color: Colors.lightText
  },
  headerTintColor: Colors.lightText,
  gestureEnabled: true,
  headerBackTitleVisible: false,
}
//specific for screens
const login = {
  headerShown: false,
}
const home = {
  headerShown: false,
}

// default styling for tab navigation
const tabBar = {
  headerShown: false,
  tabBarActiveTintColor: Colors.yellow,
  tabBarInactiveTintColor: Colors.lightGrey,
  tabBarStyle: {
    backgroundColor: Colors.blue,
    paddingTop:5,
    borderTopColor: Colors.lightBlue,
    minHeight: 64,
    ...Platform.select({
      web: {
        width: '100%',
        maxWidth: 768,
        alignSelf: 'center',
        borderTopColor: Colors.transparentBlue,
      }
    })
  },
  tabBarItemStyle: {
    height: 55,
  },
  tabBarLabelStyle: {
    fontSize: 12,
  },
  tabBarLabelPosition: 'below-icon',
}

export default {
  all,
  login,
  home,
  tabBar,
  innerStacks,
  signUp
};
